import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';

import Table from 'react-bootstrap/Table';

function Papers() {
    const [paper, setPaper] = useState([])
    const [filteredPapers, setFilteredPapers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const user = JSON.parse(localStorage.getItem("user"));
    console.log(user.accessToken);

    useEffect(()=>{
        axios
            .get('https://coda.easylinksmw.com/api/paper/getPapers', {headers : {authorization : "Bearer " + user.accessToken}})
            .then((res)=>{console.log(res);
            setPaper(res.data.papers);
            })
            .catch((err)=>console.log(err))
    }, []);

    // Filter papers by paper name only as user types
    useEffect(() => {
        const results = paper.filter(paperItem =>
            paperItem.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredPapers(results);
    }, [searchTerm, paper]);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };    

    return (
        <div className="paper-listing">
            <div><center><blockquote><b>Paper Listing</b> </blockquote></center> </div>

            {/* Search Input - Paper Name Only */}
            <div className="mb-3">
                <InputGroup>
                    <InputGroup.Text>🔍</InputGroup.Text>
                    <Form.Control
                        type="text"
                        placeholder="Search by paper name..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                    {searchTerm && (
                        <button 
                            className="btn btn-outline-secondary" 
                            type="button"
                            onClick={() => setSearchTerm("")}
                        >
                            ✕
                        </button>
                    )}
                </InputGroup>
                {/* <div className="mt-2">
                    <small className="text-muted">
                        Found {filteredPapers.length} result{filteredPapers.length !== 1 ? 's' : ''}
                    </small>
                </div> */}
            </div>

            <Table striped bordered hover variant="light">            
                <thead>
                    <tr>
                    <th>Paper Name</th>
                    <th>Subject Name</th>
                    <th>Grade Category</th>
                    <th>Grade Level</th>
                    <th>Year</th>
                    <th>Marking Script</th>
                    </tr>
                </thead>
                <tbody>
                {
                    filteredPapers && filteredPapers.map((paper)=> (
                        
                        <tr key={paper.id}>
                            <td>{paper.name}</td>
                            <td>{paper.subject}</td>
                            <td>{paper.grade_category}</td>
                            <td>{paper.grade_level}</td>
                            <td>{paper.year}</td>
                            <td>
                            {paper.script_id ? (
                                <a
                                    href={`https://coda.easylinksmw.com/api/script/${paper.script_id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    View
                                </a>
                            ) : (
                                <Link to={`/addScript/${paper.id}`}>Add</Link>
                            )}
                            </td>
                        </tr>                    
                    ))
                }
                </tbody>
            </Table>
        </div>
    );
}

export default Papers;